import { render, staticRenderFns } from "./HorizontalConfirm.vue?vue&type=template&id=a56962ae&"
import script from "./HorizontalConfirm.vue?vue&type=script&lang=js&"
export * from "./HorizontalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports